<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up courses-shell" flat>
      <div v-if="isLoading" style="padding: 60px 20px; text-align: center">
        <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
        <div class="text-h6 mt-4">Cargando capacitaciones...</div>
      </div>
      <v-card-text v-else>
        <v-row justify="end">
          <v-col cols="12" lg="5">
            <v-text-field
              class="ui-form-field"
              v-model="buscaCurso"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              hide-details
              placeholder="Buscar capacitación por nombre..."
              aria-label="Buscar capacitación por nombre"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- NIVEL 1: Años -->
            <v-data-table
              class="courses-table"
              :headers="headersAnio"
              :items="aniosVisibles"
              :expanded="expandedAnios"
              @item-expanded="onAnioExpanded"
              item-key="anio"
              show-expand
              dark
              hide-default-footer
              disable-pagination
              dense
            >
              <template v-slot:[`header.acciones`]>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      color="secondary"
                      @click="openEditDialog('anio')"
                      aria-label="Agregar año"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Registrar nuevo Año</span>
                </v-tooltip>
              </template>

              <template v-slot:[`item.anio`]="{ item }">
                <div class="nivel-pill nivel-anio">
                  <v-icon small class="mr-2">mdi-calendar</v-icon>
                  <span class="font-weight-bold">{{ item.anio }}</span>
                </div>
              </template>

              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click.stop="openEditDialog('anio', item)"
                      aria-label="Editar año"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      @click.stop="openDeleteDialog('anio', item)"
                      aria-label="Eliminar año"
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </template>

              <template v-slot:expanded-item="{ headers: hdrs, item: anioRow }">
                <td :colspan="hdrs.length" class="pa-0 nivel-anio-expanded">
                  <!-- NIVEL 2: Perfiles -->
                  <v-data-table
                    class="inner-perfil"
                    :headers="headersPerfil"
                    :items="perfilesDeAnio(anioRow)"
                    :expanded="expandedPerfiles"
                    @item-expanded="onPerfilExpanded"
                    item-key="key"
                    show-expand
                    dark
                    hide-default-footer
                    disable-pagination
                    dense
                  >
                    <template v-slot:[`header.acciones`]>
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            style="color: #a78bfa"
                            @click="openEditDialog('perfil', null, { anioRow })"
                            aria-label="Agregar perfil"
                            v-on="on"
                            v-bind="attrs"
                          >
                            <v-icon small>mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Registrar nuevo Perfil</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:[`item.perfil`]="{ item }">
                      <div class="nivel-pill nivel-perfil">
                        <v-icon small class="mr-2">mdi-account-group-outline</v-icon>
                        <span class="font-weight-medium">{{ item.perfil }}</span>
                      </div>
                    </template>

                    <template v-slot:[`item.acciones`]="{ item }">
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            @click.stop="openEditDialog('perfil', item, { anioRow })"
                            aria-label="Editar perfil"
                            v-on="on"
                            v-bind="attrs"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip bottom color="black">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            @click.stop="openDeleteDialog('perfil', item, { anioRow })"
                            aria-label="Eliminar perfil"
                            v-on="on"
                            v-bind="attrs"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:no-data>
                      <div v-if="loadingPerfiles" class="text-center py-6">
                        <v-progress-circular indeterminate color="secondary" size="32"></v-progress-circular>
                        <div class="text-body-1 mt-2">Cargando información...</div>
                      </div>
                      <div v-else class="text-body-1 text-center py-6">No hay perfiles registrados</div>
                    </template>

                    <template v-slot:expanded-item="{ headers: hdrsPerfil, item: perfilRow }">
                      <td :colspan="hdrsPerfil.length" class="pa-0 nivel-perfil-expanded">
                        <!-- NIVEL 3: Tipos -->
                        <v-data-table
                          class="inner-tipo"
                          :headers="headersTipo"
                          :items="tiposDeAnioPerfil(anioRow, perfilRow)"
                          :expanded="expandedTipos"
                          @item-expanded="onTipoExpanded"
                          item-key="key"
                          show-expand
                          dark
                          hide-default-footer
                          disable-pagination
                          dense
                        >
                          <template v-slot:[`item.tipo`]="{ item }">
                            <div class="nivel-pill nivel-tipo">
                              <v-icon small class="mr-2">mdi-tag-outline</v-icon>
                              <span class="font-weight-medium">{{ item.tipo }}</span>
                            </div>
                          </template>

                          <template v-slot:no-data>
                            <div v-if="loadingCategorias" class="text-center py-6">
                              <v-progress-circular indeterminate color="secondary" size="32"></v-progress-circular>
                              <div class="text-body-1 mt-2">Cargando información...</div>
                            </div>
                            <div v-else class="text-body-1 text-center py-6">No hay tipos registrados</div>
                          </template>

                          <template v-slot:expanded-item="{ headers: hdrsTipo, item: tipoRow }">
                            <td :colspan="hdrsTipo.length" class="pa-0 nivel-tipo-expanded">
                              <!-- NIVEL 4: Categorías -->
                              <v-data-table
                                class="inner-cat"
                                :headers="headersCat"
                                :items="categoriasDeAnioPerfilTipo(anioRow, perfilRow, tipoRow)"
                                :expanded="expandedCats"
                                @item-expanded="onCategoriaExpanded"
                                item-key="key"
                                show-expand
                                dark
                                hide-default-footer
                                disable-pagination
                                dense
                              >
                                <template v-slot:[`header.acciones`]>
                                  <v-tooltip bottom color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        style="color: #60a5fa"
                                        @click="openEditDialog('categoria', null, { anioRow, perfilRow, tipoRow })"
                                        aria-label="Agregar categoría"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        <v-icon small>mdi-plus</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Registrar nueva Categoria</span>
                                  </v-tooltip>
                                </template>

                                <template v-slot:[`item.categoria`]="{ item }">
                                  <div class="nivel-pill nivel-cat">
                                    <v-icon small class="mr-2">mdi-folder-outline</v-icon>
                                    <span class="font-weight-medium">{{ item.categoria }}</span>
                                  </div>
                                </template>

                                <template v-slot:[`item.acciones`]="{ item }">
                                  <v-tooltip bottom color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        @click.stop="openCursoDialog(null, { catRow: item })"
                                        aria-label="Agregar capacitación"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        <v-icon small>mdi-plus</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Registrar nueva Capacitación</span>
                                  </v-tooltip>
                                  <v-tooltip bottom color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        @click.stop="openEditDialog('categoria', item, { anioRow, perfilRow, tipoRow })"
                                        aria-label="Editar categoría"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        <v-icon small>mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Editar</span>
                                  </v-tooltip>
                                  <v-tooltip bottom color="black">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        @click.stop="openDeleteDialog('categoria', item, { anioRow, perfilRow, tipoRow })"
                                        aria-label="Eliminar categoría"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        <v-icon small>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Eliminar</span>
                                  </v-tooltip>
                                </template>

                                <template v-slot:no-data>
                                  <div v-if="loadingCategorias" class="text-center py-6">
                                    <v-progress-circular
                                      indeterminate
                                      color="secondary"
                                      size="32"
                                    ></v-progress-circular>
                                    <div class="text-body-1 mt-2">Cargando información...</div>
                                  </div>
                                  <div v-else class="text-body-1 text-center py-6">No hay categorías registradas</div>
                                </template>

                                <template v-slot:expanded-item="{ headers: hdrsCat, item: catRow }">
                                  <td :colspan="hdrsCat.length" class="pa-0 nivel-cat-expanded">
                                    <!-- NIVEL 5: Cursos -->
                                    <v-list dense class="cursos-list">
                                      <v-list-item v-for="curso in catRow.cursos" :key="curso.id" class="curso-item">
                                        <v-list-item-content>
                                          <v-list-item-title class="curso-nombre">
                                            <span class="curso-dot">•</span>
                                            <span v-html="highlightMatch(curso.subcategoria)"></span>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action class="flex-row align-center ma-0">
                                          <v-tooltip bottom color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                :to="{ name: 'evaluaCandidatosCapacitacion', params: { id: curso.id } }"
                                                class="curso-action-btn mx-1"
                                                icon
                                                v-on="on"
                                                v-bind="attrs"
                                              >
                                                <v-icon small>mdi-clipboard-check-outline</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Registrar calificaciones</span>
                                          </v-tooltip>
                                          <v-tooltip bottom color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                :to="{ name: 'registroCandidatosCapacitacion', params: { id: curso.id } }"
                                                class="curso-action-btn mx-1"
                                                icon
                                                v-on="on"
                                                v-bind="attrs"
                                              >
                                                <v-icon small>mdi-account-plus</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Registrar candidatos</span>
                                          </v-tooltip>
                                          <v-tooltip bottom color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                :to="{ name: 'programarCurso', params: { id: curso.id } }"
                                                class="curso-action-btn mx-1"
                                                icon
                                                v-on="on"
                                                v-bind="attrs"
                                              >
                                                <v-icon small>mdi-calendar-clock</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Programar capacitación</span>
                                          </v-tooltip>
                                          <v-tooltip bottom color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                class="curso-action-btn mx-1"
                                                icon
                                                v-on="on"
                                                v-bind="attrs"
                                                @click="openCursoDialog(curso, { catRow })"
                                              >
                                                <v-icon small>mdi-pencil</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Editar capacitación</span>
                                          </v-tooltip>
                                          <v-tooltip bottom color="black">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                                class="curso-action-btn mx-1"
                                                icon
                                                v-on="on"
                                                v-bind="attrs"
                                                @click="openDeleteDialog('subcategoria', { descripcion: curso.subcategoria, idSubcategoria: curso.id })"
                                                aria-label="Eliminar capacitación"
                                              >
                                                <v-icon small>mdi-delete</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Eliminar capacitación</span>
                                          </v-tooltip>
                                        </v-list-item-action>
                                      </v-list-item>
                                    </v-list>
                                  </td>
                                </template>
                              </v-data-table>
                            </td>
                          </template>
                        </v-data-table>
                      </td>
                    </template>
                  </v-data-table>
                </td>
              </template>

              <template v-slot:no-data>
                <div v-if="isLoading" class="text-center py-8">
                  <v-progress-circular indeterminate color="secondary" size="40"></v-progress-circular>
                  <div class="text-h6 mt-3">Cargando información...</div>
                </div>
                <div v-else class="text-h6 text-center py-8">No hay cursos registrados</div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Dialog de creación/edición para año, perfil y categoría -->
    <v-dialog v-model="showEditDialog" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-h6">{{ editDialogTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="editForm" v-model="editFormValid">
            <v-text-field
              v-model="editForm.descripcion"
              label="Descripción"
              :rules="[(v) => !!v || 'La descripción es requerida']"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditDialog">Cancelar</v-btn>
          <v-btn color="secondary" text :loading="isSavingEdit" :disabled="isSavingEdit" @click="confirmEditDialog"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de creación/edición de capacitación (subcategoría/curso) -->
    <v-dialog v-model="showCursoDialog" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-h6">{{ cursoDialogTitle }}</v-card-title>
        <v-card-text>
          <v-form ref="cursoForm" v-model="cursoFormValid">
            <v-text-field
              v-model="cursoForm.subcategoria"
              label="Subcategoría (nombre de la capacitación)"
              :rules="cursoNameRules"
              required
            ></v-text-field>
            <v-text-field
              v-model.number="cursoForm.puntaje"
              type="number"
              label="Puntaje"
              :rules="cursoPuntajeRules"
              required
            ></v-text-field>
            <v-textarea v-model="cursoForm.observaciones" label="Observaciones" no-resize rows="3"></v-textarea>
            <v-file-input
              v-model="cursoForm.file"
              label="Adjuntar documento de la capacitación .jpg"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeCursoDialog">Cancelar</v-btn>
          <v-btn color="secondary" text :loading="isSavingCurso" :disabled="isSavingCurso" @click="confirmCursoDialog"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de confirmación de baja para año, perfil, categoría y subcategoría -->
    <v-dialog v-model="showDeleteDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6">Confirmar eliminación</v-card-title>
        <v-card-text>
          ¿Está seguro de eliminar {{ deleteEntityLabel }} <strong>{{ itemToDelete && itemToDelete.descripcion }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDeleteDialog">Cancelar</v-btn>
          <v-btn color="error" text :loading="isDeleting" :disabled="isDeleting" @click="confirmDeleteDialog"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      isLoading: false,
      loadingPerfiles: false,
      loadingCategorias: false,
      buscaCurso: '',
      expandedAnios: [],
      expandedPerfiles: [],
      expandedTipos: [],
      expandedCats: [],
      headersAnio: [
        { text: 'Año', value: 'anio', sortable: false },
        { text: '', value: 'acciones', sortable: false, align: 'right' },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersPerfil: [
        { text: 'Perfil', value: 'perfil', sortable: false },
        { text: '', value: 'acciones', sortable: false, align: 'right' },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersTipo: [
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      headersCat: [
        { text: 'Categoría', value: 'categoria', sortable: false },
        { text: '', value: 'acciones', sortable: false, align: 'right' },
        { text: '', value: 'data-table-expand', sortable: false, align: 'right' },
      ],
      showEditDialog: false,
      editEntity: null,
      editForm: { descripcion: '' },
      editFormValid: false,
      editContext: null,
      isSavingEdit: false,
      showDeleteDialog: false,
      deleteEntity: null,
      itemToDelete: null,
      deleteContext: null,
      isDeleting: false,
      showCursoDialog: false,
      cursoForm: { subcategoria: '', puntaje: 0, observaciones: '', file: null },
      cursoFormValid: false,
      cursoContext: null,
      isSavingCurso: false,
      cursoNameRules: [(v) => !!v || 'Este campo es requerido.'],
      cursoPuntajeRules: [(v) => !!v || 'Ingrese un puntaje válido.', (v) => v > 0 || 'Ingrese un puntaje válido.'],
    }
  },

  computed: {
    ...mapGetters('capacitaciones', {
      aniosCursos: 'getAniosCursos',
      getPerfilesCursosDeAnio: 'getPerfilesCursosDeAnio',
      getCategoriasDePerfilCurso: 'getCategoriasDePerfilCurso',
      getCategoriasCatalogo: 'getCategorias',
      catalogoNavegacion: 'getCatalogoNavegacion',
    }),
    ...mapGetters('curso', { cursosCatalogo: 'getCursos' }),

    isSearching() {
      return (this.buscaCurso || '').trim().length > 0
    },

    aniosVisibles() {
      return this.aniosCursos.map((a) => ({ anio: a.title, idAnioCurso: a.id }))
    },

    editDialogTitle() {
      const labels = { anio: 'año', perfil: 'perfil', categoria: 'categoría' }
      const label = labels[this.editEntity] || ''
      return (this.itemBeingEdited ? 'Editar ' : 'Nuevo ') + label
    },

    itemBeingEdited() {
      return !!(this.editContext && this.editContext.item)
    },

    deleteEntityLabel() {
      const labels = { anio: 'el año', perfil: 'el perfil', categoria: 'la categoría', subcategoria: 'el curso' }
      return labels[this.deleteEntity] || 'el registro'
    },

    cursoBeingEdited() {
      return !!(this.cursoContext && this.cursoContext.item)
    },

    cursoDialogTitle() {
      return this.cursoBeingEdited ? 'Editar capacitación' : 'Nueva capacitación'
    },
  },

  watch: {
    buscaCurso(value) {
      this.SET_CATALOGO_NAVEGACION({ buscaCurso: value })
    },
  },

  async mounted() {
    this.isLoading = true
    try {
      await Promise.all([this.fetchAniosCursos(), this.fetchCursos()])
      await this.restaurarNavegacion()
    } finally {
      this.isLoading = false
    }
  },

  methods: {
    ...mapActions('capacitaciones', [
      'fetchAniosCursos',
      'fetchPerfilesCursosByAnioCurso',
      'fetchCategoriasByPerfilCurso',
      'crearAnioCurso',
      'actualizarAnioCurso',
      'desactivarAnioCurso',
      'crearPerfilCurso',
      'actualizarPerfilCurso',
      'desactivarPerfilCurso',
      'crearCategoria',
      'actualizarCategoria',
      'desactivarCategoria',
      'desactivarSubcategoria',
    ]),
    ...mapActions('curso', ['fetchCursos', 'saveCurso', 'updateCurso']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('capacitaciones', ['SET_CATALOGO_NAVEGACION']),

    async restaurarNavegacion() {
      const nav = this.catalogoNavegacion
      this.buscaCurso = nav.buscaCurso || ''
      if (!nav.expandedAnio) return

      const anioRow = this.aniosVisibles.find((a) => a.idAnioCurso === nav.expandedAnio)
      if (!anioRow) return
      this.expandedAnios = [anioRow]
      this.loadingPerfiles = true
      try {
        await this.fetchPerfilesCursosByAnioCurso(anioRow.idAnioCurso)
      } finally {
        this.loadingPerfiles = false
      }

      if (!nav.expandedPerfil) return
      const perfilRow = this.perfilesDeAnio(anioRow).find((p) => p.idPerfilCurso === nav.expandedPerfil)
      if (!perfilRow) return
      this.expandedPerfiles = [perfilRow]
      this.loadingCategorias = true
      try {
        await this.fetchCategoriasByPerfilCurso(perfilRow.idPerfilCurso)
      } finally {
        this.loadingCategorias = false
      }

      if (!nav.expandedTipo) return
      const tipoRow = this.tiposDeAnioPerfil(anioRow, perfilRow).find((t) => t.idTipoCurso === nav.expandedTipo)
      if (!tipoRow) return
      this.expandedTipos = [tipoRow]

      if (!nav.expandedCategoria) return
      const catRow = this.categoriasDeAnioPerfilTipo(anioRow, perfilRow, tipoRow).find(
        (c) => c.idCategoria === nav.expandedCategoria
      )
      if (!catRow) return
      this.expandedCats = [catRow]
    },

    perfilesDeAnio(anioRow) {
      return this.getPerfilesCursosDeAnio.map((p) => ({
        key: `${anioRow.anio}-${p.id}`,
        perfil: p.descripcion,
        idPerfilCurso: p.id,
      }))
    },

    tiposDeAnioPerfil(anioRow, perfilRow) {
      const idsVistos = new Set()
      const tipos = []
      this.getCategoriasCatalogo.forEach((cat) => {
        const idTipoCurso = cat.fk_idTipoCurso
        if (idsVistos.has(idTipoCurso)) return
        idsVistos.add(idTipoCurso)
        tipos.push({ key: `${perfilRow.key}-${idTipoCurso}`, tipo: cat.catTipoCurso?.title, idTipoCurso })
      })
      return tipos
    },

    // El módulo legacy de cursos (curso.js) y el catálogo nuevo (capacitaciones)
    // usan IDs de categoría distintos para la misma categoría lógica, así que
    // el vínculo se resuelve por nombre + tipo normalizados. Dos categorías
    // homónimas bajo el mismo tipo pero distinto perfil seguirían colisionando;
    // resolverlo del todo requeriría que el backend exponga el ID legacy real.
    categoriasDeAnioPerfilTipo(anioRow, perfilRow, tipoRow) {
      const search = this.buscaCurso.toLowerCase().trim()
      const categoriasDelTipo = this.getCategoriasDePerfilCurso.filter(
        (cat) => cat.fk_idTipoCurso === tipoRow.idTipoCurso
      )
      return categoriasDelTipo
        .map((cat) => ({
          key: `${tipoRow.key}-${cat.id}`,
          categoria: cat.categoria,
          idCategoria: cat.id,
          cursos: this.cursosCatalogo.filter(
            (curso) =>
              this.normalizaTexto(curso.CatCategoria?.categoria) === this.normalizaTexto(cat.categoria) &&
              curso.CatCategoria?.fkidTipoCurso === tipoRow.idTipoCurso &&
              (!search || (curso.subcategoria || '').toLowerCase().includes(search))
          ),
        }))
        .filter((catRow) => !this.isSearching || catRow.cursos.length > 0)
    },

    highlightMatch(value) {
      const text = value || ''
      if (!this.isSearching) return this.escapeHtml(text)
      const escapedText = this.escapeHtml(text)
      // El filtro compara contra el texto sin escapar; si el nombre del curso
      // contiene caracteres HTML especiales (&, <, >, ", '), el query no
      // coincidirá aquí porque escapedText sí los tiene escapados. Caso
      // extremo: el curso se filtra correctamente pero pierde el resaltado.
      const query = this.escapeRegExp(this.buscaCurso.trim())
      if (!query) return escapedText
      return escapedText.replace(new RegExp(`(${query})`, 'ig'), '<mark class="search-highlight">$1</mark>')
    },

    escapeHtml(value) {
      return (value || '')
        .toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },

    async onAnioExpanded({ item, value }) {
      this.expandedAnios = value ? [item] : []
      this.expandedPerfiles = []
      this.expandedTipos = []
      this.expandedCats = []
      this.SET_CATALOGO_NAVEGACION({
        expandedAnio: value ? item.idAnioCurso : null,
        expandedPerfil: null,
        expandedTipo: null,
        expandedCategoria: null,
      })

      if (value && item.idAnioCurso) {
        this.loadingPerfiles = true
        try {
          await this.fetchPerfilesCursosByAnioCurso(item.idAnioCurso)
        } finally {
          this.loadingPerfiles = false
        }
      }
    },

    async onPerfilExpanded({ item, value }) {
      this.expandedPerfiles = value ? [item] : []
      this.expandedTipos = []
      this.expandedCats = []
      this.SET_CATALOGO_NAVEGACION({
        expandedPerfil: value ? item.idPerfilCurso : null,
        expandedTipo: null,
        expandedCategoria: null,
      })

      if (value && item.idPerfilCurso) {
        this.loadingCategorias = true
        try {
          await this.fetchCategoriasByPerfilCurso(item.idPerfilCurso)
        } finally {
          this.loadingCategorias = false
        }
      }
    },

    onTipoExpanded({ item, value }) {
      this.expandedTipos = value ? [item] : []
      this.expandedCats = []
      this.SET_CATALOGO_NAVEGACION({
        expandedTipo: value ? item.idTipoCurso : null,
        expandedCategoria: null,
      })
    },

    onCategoriaExpanded({ item, value }) {
      this.expandedCats = value ? [item] : []
      this.SET_CATALOGO_NAVEGACION({ expandedCategoria: value ? item.idCategoria : null })
    },

    escapeRegExp(value) {
      return (value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },

    normalizaTexto(value) {
      return (value || '').trim().toLowerCase()
    },

    openEditDialog(entity, item = null, context = null) {
      this.editEntity = entity
      this.editContext = { item, ...context }
      this.editForm = { descripcion: item ? item.perfil || item.categoria || item.anio : '' }
      this.showEditDialog = true
      this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.resetValidation())
    },

    closeEditDialog() {
      this.showEditDialog = false
      this.editEntity = null
      this.editContext = null
      this.editForm = { descripcion: '' }
    },

    async confirmEditDialog() {
      if (!this.$refs.editForm.validate()) return
      this.isSavingEdit = true
      try {
        if (this.editEntity === 'anio') await this.saveAnio()
        else if (this.editEntity === 'perfil') await this.savePerfil()
        else if (this.editEntity === 'categoria') await this.saveCategoria()
        this.closeEditDialog()
      } catch (error) {
        // El mensaje de error de negocio ya se muestra vía SET_SNACKBAR_MESSAGE en el store.
        // Se registra aquí para no ocultar errores de programación inesperados.
        console.error(error)
      } finally {
        this.isSavingEdit = false
      }
    },

    async saveAnio() {
      const { item } = this.editContext
      const descripcion = this.editForm.descripcion
      if (item) {
        await this.actualizarAnioCurso({ idAnioCurso: item.idAnioCurso, payload: { descripcion } })
      } else {
        await this.crearAnioCurso({ descripcion })
      }
    },

    async savePerfil() {
      const { item, anioRow } = this.editContext
      const payload = { fk_idCatAnioCurso: anioRow.idAnioCurso, descripcion: this.editForm.descripcion }
      if (item) {
        await this.actualizarPerfilCurso({ idPerfilCurso: item.idPerfilCurso, payload })
      } else {
        await this.crearPerfilCurso(payload)
      }
    },

    async saveCategoria() {
      const { item, perfilRow, tipoRow } = this.editContext
      const payload = {
        categoria: this.editForm.descripcion,
        fk_idTipoCurso: tipoRow.idTipoCurso,
        fk_idCatPerfilCurso: perfilRow.idPerfilCurso,
      }
      if (item) {
        await this.actualizarCategoria({ idCategoria: item.idCategoria, payload })
      } else {
        await this.crearCategoria(payload)
      }
    },

    openDeleteDialog(entity, item, context = null) {
      this.deleteEntity = entity
      this.itemToDelete = { ...item, descripcion: item.perfil || item.categoria || item.anio || item.descripcion }
      this.deleteContext = context
      this.showDeleteDialog = true
    },

    closeDeleteDialog() {
      this.showDeleteDialog = false
      this.deleteEntity = null
      this.itemToDelete = null
      this.deleteContext = null
    },

    async confirmDeleteDialog() {
      this.isDeleting = true
      try {
        if (this.deleteEntity === 'anio') {
          await this.desactivarAnioCurso(this.itemToDelete.idAnioCurso)
        } else if (this.deleteEntity === 'perfil') {
          await this.desactivarPerfilCurso({
            idPerfilCurso: this.itemToDelete.idPerfilCurso,
            idAnioCurso: this.deleteContext.anioRow.idAnioCurso,
          })
        } else if (this.deleteEntity === 'categoria') {
          await this.desactivarCategoria({
            idCategoria: this.itemToDelete.idCategoria,
            idTipoCurso: this.deleteContext.tipoRow.idTipoCurso,
            idCatPerfilCurso: this.deleteContext.perfilRow.idPerfilCurso,
          })
        } else if (this.deleteEntity === 'subcategoria') {
          await this.desactivarSubcategoria(this.itemToDelete.idSubcategoria)
        }
        this.closeDeleteDialog()
      } catch (error) {
        // El mensaje de error de negocio ya se muestra vía SET_SNACKBAR_MESSAGE en el store.
        // Se registra aquí para no ocultar errores de programación inesperados.
        console.error(error)
      } finally {
        this.isDeleting = false
      }
    },

    openCursoDialog(curso = null, context = null) {
      this.cursoContext = { item: curso, ...context }
      this.cursoForm = curso
        ? {
            id: curso.id,
            fk_idCategoria: curso.fk_idCategoria,
            subcategoria: curso.subcategoria,
            puntaje: curso.puntaje,
            observaciones: curso.observaciones,
            file: null,
          }
        : { subcategoria: '', puntaje: 0, observaciones: '', file: null }
      this.showCursoDialog = true
      this.$nextTick(() => this.$refs.cursoForm && this.$refs.cursoForm.resetValidation())
    },

    closeCursoDialog() {
      this.showCursoDialog = false
      this.cursoContext = null
      this.cursoForm = { subcategoria: '', puntaje: 0, observaciones: '', file: null }
    },

    async confirmCursoDialog() {
      if (!this.$refs.cursoForm.validate()) return
      this.isSavingCurso = true
      try {
        if (this.cursoBeingEdited) {
          await this.updateCurso(this.cursoForm)
        } else {
          const payload = { ...this.cursoForm, fk_idCategoria: this.cursoContext.catRow.idCategoria }
          await this.saveCurso(payload)
        }
        await this.fetchCursos()
        this.closeCursoDialog()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE(error.message || 'No fue posible guardar la capacitación.')
      } finally {
        this.isSavingCurso = false
      }
    },
  },
}
</script>

<style scoped>
/* ─── Variables de color por nivel ──────────────────────────────────
   Año      → verde   #26de81
   Tipo     → naranja #fbbf24
   Categoría→ azul    #60a5fa
   Cursos   → blanco  #e0e0e0
─────────────────────────────────────────────────────────────────── */

/* Búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}
::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}
::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}
::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}
::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(38, 222, 129, 0.75) !important;
}

/* ─── Pill compartido ─── */
.nivel-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.875rem;
}
.nivel-anio {
  background: rgba(38, 222, 129, 0.15);
  color: #26de81 !important;
  border: 1px solid rgba(38, 222, 129, 0.35);
}
.nivel-perfil {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa !important;
  border: 1px solid rgba(167, 139, 250, 0.35);
}
.nivel-tipo {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24 !important;
  border: 1px solid rgba(251, 191, 36, 0.35);
}
.nivel-cat {
  background: rgba(96, 165, 250, 0.15);
  color: #60a5fa !important;
  border: 1px solid rgba(96, 165, 250, 0.35);
}

/* ─── NIVEL 1: tabla de años ─── */
::v-deep .courses-table.v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
  border: 1px solid rgba(38, 222, 129, 0.2);
  overflow: hidden;
}
::v-deep .courses-table > .v-data-table__wrapper,
::v-deep .courses-table > .v-data-table__wrapper > table,
::v-deep .courses-table > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .courses-table > .v-data-table__wrapper > table > thead {
  background: rgba(38, 222, 129, 0.12) !important;
}
::v-deep .courses-table .v-data-table-header th {
  color: #26de81 !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  border-bottom: 2px solid rgba(38, 222, 129, 0.3) !important;
  padding: 18px 20px !important;
  background: transparent !important;
}
::v-deep .courses-table tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .courses-table tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(38, 222, 129, 0.06) !important;
}
::v-deep .courses-table tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(38, 222, 129, 0.1) !important;
  padding: 16px 20px !important;
}
::v-deep .courses-table .v-data-table__expand-icon {
  color: #26de81 !important;
}
::v-deep .courses-table .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 2px solid rgba(38, 222, 129, 0.2) !important;
}

/* ─── NIVEL 2: tabla de perfiles ─── */
.nivel-anio-expanded {
  border-left: 4px solid rgba(38, 222, 129, 0.4);
}

::v-deep .inner-perfil.v-data-table {
  background: rgba(167, 139, 250, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .inner-perfil > .v-data-table__wrapper,
::v-deep .inner-perfil > .v-data-table__wrapper > table,
::v-deep .inner-perfil > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .inner-perfil > .v-data-table__wrapper > table > thead {
  background: rgba(167, 139, 250, 0.08) !important;
}
::v-deep .inner-perfil .v-data-table-header th {
  color: #a78bfa !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(167, 139, 250, 0.25) !important;
  padding: 16px 20px 16px 28px !important;
  background: transparent !important;
}
::v-deep .inner-perfil tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .inner-perfil tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(167, 139, 250, 0.06) !important;
}
::v-deep .inner-perfil tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(167, 139, 250, 0.08) !important;
  padding: 16px 20px 16px 28px !important;
}
::v-deep .inner-perfil .v-data-table__expand-icon {
  color: #a78bfa !important;
}
::v-deep .inner-perfil .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(167, 139, 250, 0.15) !important;
}

/* ─── NIVEL 3: tabla de tipos ─── */
.nivel-perfil-expanded {
  border-left: 4px solid rgba(167, 139, 250, 0.4);
}

::v-deep .inner-tipo.v-data-table {
  background: rgba(251, 191, 36, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .inner-tipo > .v-data-table__wrapper,
::v-deep .inner-tipo > .v-data-table__wrapper > table,
::v-deep .inner-tipo > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .inner-tipo > .v-data-table__wrapper > table > thead {
  background: rgba(251, 191, 36, 0.08) !important;
}
::v-deep .inner-tipo .v-data-table-header th {
  color: #fbbf24 !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(251, 191, 36, 0.25) !important;
  padding: 16px 20px 16px 28px !important;
  background: transparent !important;
}
::v-deep .inner-tipo tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .inner-tipo tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(251, 191, 36, 0.06) !important;
}
::v-deep .inner-tipo tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(251, 191, 36, 0.08) !important;
  padding: 16px 20px 16px 28px !important;
}
::v-deep .inner-tipo .v-data-table__expand-icon {
  color: #fbbf24 !important;
}
::v-deep .inner-tipo .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(251, 191, 36, 0.15) !important;
}

/* ─── NIVEL 3: tabla de categorías ─── */
.nivel-tipo-expanded {
  border-left: 4px solid rgba(251, 191, 36, 0.4);
}

::v-deep .inner-cat.v-data-table {
  background: rgba(96, 165, 250, 0.03) !important;
  border-radius: 0 !important;
}
::v-deep .inner-cat > .v-data-table__wrapper,
::v-deep .inner-cat > .v-data-table__wrapper > table,
::v-deep .inner-cat > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}
::v-deep .inner-cat > .v-data-table__wrapper > table > thead {
  background: rgba(96, 165, 250, 0.08) !important;
}
::v-deep .inner-cat .v-data-table-header th {
  color: #60a5fa !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 1px solid rgba(96, 165, 250, 0.25) !important;
  padding: 16px 20px 16px 36px !important;
  background: transparent !important;
}
::v-deep .inner-cat tbody tr:not(.v-data-table__expanded) {
  background: transparent !important;
  transition: background 0.2s;
}
::v-deep .inner-cat tbody tr:not(.v-data-table__expanded):hover {
  background: rgba(96, 165, 250, 0.06) !important;
}
::v-deep .inner-cat tbody td {
  background: transparent !important;
  border-bottom: 1px solid rgba(96, 165, 250, 0.08) !important;
  padding: 16px 20px 16px 36px !important;
}
::v-deep .inner-cat .v-data-table__expand-icon {
  color: #60a5fa !important;
}
::v-deep .inner-cat .v-data-table__expanded.v-data-table__expanded__content > td {
  background: transparent !important;
  padding: 0 !important;
  border-bottom: 1px solid rgba(96, 165, 250, 0.15) !important;
}

/* ─── NIVEL 4: lista de cursos ─── */
.nivel-cat-expanded {
  border-left: 4px solid rgba(96, 165, 250, 0.4);
}

.cursos-list {
  background: transparent !important;
  padding: 6px 0 !important;
}
.curso-item {
  padding: 10px 20px 10px 48px !important;
  min-height: 46px !important;
  border-bottom: 1px solid rgba(224, 224, 224, 0.06) !important;
  border-left: 3px solid transparent !important;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease !important;
  cursor: default;
}
.curso-item:last-child {
  border-bottom: none !important;
}
.curso-item:hover {
  transform: translateX(6px) !important;
  background: rgba(96, 165, 250, 0.07) !important;
  border-left-color: #60a5fa !important;
  box-shadow: -3px 0 12px rgba(96, 165, 250, 0.15), inset 0 0 20px rgba(96, 165, 250, 0.04) !important;
}

.curso-nombre {
  color: #e0e0e0 !important;
  font-size: 0.875rem !important;
  display: flex;
  align-items: center;
  gap: 8px;
}
.curso-dot {
  color: #60a5fa;
  font-size: 1.2rem;
  line-height: 1;
  flex-shrink: 0;
}

.curso-action-btn {
  color: #60a5fa !important;
  transition: color 0.2s ease, background 0.2s ease !important;
}
.curso-action-btn:hover {
  background: rgba(96, 165, 250, 0.12) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

.search-highlight {
  background-color: rgba(255, 214, 10, 0.45);
  border-radius: 2px;
  padding: 0 2px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

.courses-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
.courses-shell:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
